<template>
  <div ref="input" class="input full" >
    <div class="choices">
      <div
        v-for="choice in input.choices"
        class="choice"
        :class="{chosen: answer == choice} "
        @click="chooseAnswer(choice)"
      >{{choice}}</div>
      
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectInput",
  props: ["input", "questionIndex", "answerKey"],
  data() {
    return {
      answer: null
    };
  },
  mounted() {},
  created() {
    this.answer = this.input.value;
    if(this.optional){
        this.$parent.question =+ "(optional)";
      }
  },
  firestore() {
    return {};
  },
  methods: {
    saveAnswer(e) {
      
      this.$emit(
        "updateAnswer",
        this.questionIndex,
        this.answerKey,
        this.answer
      );
    },
    chooseAnswer(choice) {
      this.answer = choice;
      this.saveAnswer();
    }
  },
  watch: {}
};
</script>

<style scoped lang='scss'>
.choices {
  display: flex;
  flex-direction: column;
}
.choice {
  width: 100%;
  color: #0b6efb;
  padding: 10px 20px;
  margin-bottom: 10px;
  background-color: white;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 2px lightgray;
  border: 2px solid transparent;
  transition: border 0.3s;
}
.choice.chosen {
  box-shadow: 0px 0px;
  border: 2px solid #0b6efb;
}
</style>
